"use client";

import { useEffect } from "react";
import { firePricingViewed } from "@/lib/tracking/chatgptAds";

/** `app/pricing/page.tsx` is `force-static`, so this tiny client leaf fires the view event on mount. */
export default function ChatGptAdsPricingView() {
  useEffect(() => {
    firePricingViewed();
  }, []);

  return null;
}
